<app-progress></app-progress>
<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<div class="mat-typography mt-4">
    <mat-card class="w-full md:w-1/2 mx-auto bg-gray-50 p-4">
    <mat-card-header>
      <mat-card-title>
        Location
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form (ngSubmit)="submit()" [formGroup]="locationForm">
        <mat-form-field class="form-field-full-width">
          <input class="form-group" formControlName="name" matInput placeholder="Location name" required
            type="text">
          @if (locationForm.get('name').hasError('required')) {
            <mat-error>Name is required</mat-error>
          }
          @if (locationForm.get('name').hasError('duplicate')) {
            <mat-error>
            Location {{locationForm.get('name').value}} already exists in {{facilityName}}</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-select formControlName="type" placeholder="Type" required>
            @for (type of types; track type) {
              <mat-option [value]="type.value">
                {{type.name}}
              </mat-option>
            }
          </mat-select>
          @if (locationForm.get('type').hasError('required')) {
            <mat-error>Please select a Location Type</mat-error>
          }
        </mat-form-field>
        <div class="button-row">
          <button [disabled]="locationForm.invalid" color="primary" mat-raised-button type="submit">Save
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
